'use client';

import type { ReactNode, CSSProperties, FC } from 'react';
import { EmblaOptionsType } from 'embla-carousel';
import useEmblaCarousel from 'embla-carousel-react';
import ClassNames from 'embla-carousel-class-names';
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures';

type PropType = {
   slides: ReactNode[];
   options?: EmblaOptionsType;
   slideWidth?: string;
   gap?: number;
   style?: CSSProperties;
};

const EmblaCarousel: FC<PropType> = ({ slides, options, slideWidth, gap, style }: PropType) => {
   const [emblaRef] = useEmblaCarousel(
      { ...options, align: 'start', containScroll: 'trimSnaps', dragFree: true },
      [ClassNames(), WheelGesturesPlugin()]
   );

   return (
      <div style={{ overflow: 'hidden' }}>
         <div className="embla" style={{ margin: 'auto', ...style }}>
            <div className="embla__viewport" ref={emblaRef}>
               <div
                  className="embla__container"
                  style={{
                     display: 'flex',
                     justifyContent: 'space-between',
                     gap: `${gap ?? 32}px`,
                     touchAction: 'pan-y pinch-zoom',
                  }}
               >
                  {slides.map((slide, index) => (
                     <div
                        className="embla__slide"
                        key={index}
                        style={{
                           flex: `0 0 ${slideWidth ?? 'auto'}`,
                           display: 'flex',
                           placeContent: 'center',
                        }}
                     >
                        {slide}
                     </div>
                  ))}
               </div>
            </div>
         </div>
      </div>
   );
};

export default EmblaCarousel;
